import { Group } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconGroup12Line = createIcon(Group, 12, "Line");
export const IconGroup16Line = createIcon(Group, 16, "Line");
export const IconGroup20Line = createIcon(Group, 20, "Line");
export const IconGroup24Line = createIcon(Group, 24, "Line");
export const IconGroup32Line = createIcon(Group, 32, "Line");
export const IconGroup48Line = createIcon(Group, 48, "Line");
export const IconGroup64Line = createIcon(Group, 64, "Line");
